import React, { useContext } from "react";
import { AppContext } from "../../../context/AppContext";
import { StyledNavigationCashier } from "./styles";

const options = ["Get Coins", "Account", "How It Works"];

const NavigationCashier = () => {
  const { selectedOptionCashier, updateCashierOption } = useContext(AppContext);

  return (
    <StyledNavigationCashier>
      <div className="options-container">
        {options.map((option) => (
          <div
            key={option}
            className={`option ${
              selectedOptionCashier === option ? "active-option" : ""
            }`}
            onClick={() => updateCashierOption(option)}
          >
            {option}
          </div>
        ))}
      </div>
    </StyledNavigationCashier>
  );
};

export default NavigationCashier;
